"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.uploadLocalImage = uploadLocalImage;
var _systemSetting = require("@/api/systemSetting");
var _elementUi = require("element-ui");
/**
 * 本地图片上传工具函数
 * @param {Object} options 配置选项
 * @param {Function} options.onSuccess 上传成功回调
 * @param {Function} options.onError 上传失败回调
 * @param {Function} options.onComplete 上传完成回调(无论成功失败)
 * @param {Boolean} options.multiple 是否允许多选
 * @param {Number} options.maxCount 最大上传数量(仅当multiple为true时有效)
 * @param {String} options.model 上传模块名称
 * @param {Number} options.pid 分类ID
 * @param {String} options.accept 接受的文件类型
 */
function uploadLocalImage() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$onSuccess = options.onSuccess,
    onSuccess = _options$onSuccess === void 0 ? function () {} : _options$onSuccess,
    _options$onError = options.onError,
    onError = _options$onError === void 0 ? function () {} : _options$onError,
    _options$onComplete = options.onComplete,
    onComplete = _options$onComplete === void 0 ? function () {} : _options$onComplete,
    _options$multiple = options.multiple,
    multiple = _options$multiple === void 0 ? false : _options$multiple,
    _options$maxCount = options.maxCount,
    maxCount = _options$maxCount === void 0 ? 5 : _options$maxCount,
    _options$model = options.model,
    model = _options$model === void 0 ? 'product' : _options$model,
    _options$pid = options.pid,
    pid = _options$pid === void 0 ? 1 : _options$pid,
    _options$accept = options.accept,
    accept = _options$accept === void 0 ? 'image/*' : _options$accept,
    _options$maxSizeInMB = options.maxSizeInMB,
    maxSizeInMB = _options$maxSizeInMB === void 0 ? 10 : _options$maxSizeInMB,
    _options$maxSizeKB = options.maxSizeKB,
    maxSizeKB = _options$maxSizeKB === void 0 ? 0 : _options$maxSizeKB,
    _options$maxSizeError = options.maxSizeErrorMsg,
    maxSizeErrorMsg = _options$maxSizeError === void 0 ? '' : _options$maxSizeError;

  // 创建一个隐藏的文件输入框
  var input = document.createElement('input');
  input.type = 'file';
  input.multiple = multiple;
  input.accept = accept;

  // 处理文件选择事件
  input.onchange = function (e) {
    var files = e.target.files;
    if (!files || !files.length) {
      return;
    }

    // 如果是多选，限制最大数量
    var selectedFiles = multiple ? Array.from(files).slice(0, maxCount) : [files[0]];
    if (multiple && files.length > maxCount) {
      console.warn("\u6700\u591A\u53EA\u80FD\u9009\u62E9".concat(maxCount, "\u5F20\u56FE\u7247\uFF0C\u5DF2\u81EA\u52A8\u9009\u62E9\u524D").concat(maxCount, "\u5F20"));
    }

    // 显示上传中的loading状态
    var loadingInstance = _elementUi.Loading.service({
      lock: true,
      text: '图片上传中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });

    // 记录上传成功的数量和URL
    var successCount = 0;
    var successUrls = [];

    // 记录上传失败的次数
    var errorCount = 0;

    // 记录上传的总数
    var totalCount = selectedFiles.length;

    // 处理每个文件
    selectedFiles.forEach(function (file) {
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        console.error('请选择图片文件！');
        onError(new Error('请选择图片文件'));
        errorCount++;
        totalCount--;
        if (totalCount === 0 && loadingInstance) {
          loadingInstance.close();
          onComplete(successUrls, errorCount);
        }
        return;
      }

      // 验证文件大小
      var maxSizeInBytes = maxSizeKB > 0 ? maxSizeKB * 1024 : maxSizeInMB * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        var errorMsg = maxSizeErrorMsg || (maxSizeKB > 0 ? "\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(maxSizeKB, "KB\uFF01") : "\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(maxSizeInMB, "MB\uFF01\u5F53\u524D\u6587\u4EF6\u5927\u5C0F: ").concat((file.size / 1024 / 1024).toFixed(2), "MB"));
        console.error(errorMsg);
        onError(new Error(errorMsg));
        errorCount++;
        totalCount--;
        if (totalCount === 0 && loadingInstance) {
          loadingInstance.close();
          onComplete(successUrls, errorCount);
        }
        return;
      }

      // 检查图片比例是否为1:1
      var reader = new FileReader();
      reader.onload = function (evt) {
        var img = new Image();
        img.onload = function () {
          var ratio = this.width / this.height;
          // 允许有一点误差
          if (options.validateAspectRatio && Math.abs(ratio - 1) > 0.05) {
            console.error('请上传1:1比例的图片！当前比例: ' + ratio.toFixed(2));
            onError(new Error("\u8BF7\u4E0A\u4F201:1\u6BD4\u4F8B\u7684\u56FE\u7247\uFF01\u5F53\u524D\u6BD4\u4F8B: ".concat(ratio.toFixed(2))));
            errorCount++;
            totalCount--;
            if (totalCount === 0 && loadingInstance) {
              loadingInstance.close();
              onComplete(successUrls, errorCount);
            }
            return;
          }

          // 图片验证通过，继续上传流程
          // 创建FormData对象用于上传
          var formData = new FormData();
          formData.append('multipart', file);

          // 设置上传参数
          var params = {
            model: model,
            pid: pid
          };

          // 调用API上传图片
          (0, _systemSetting.fileImageApi)(formData, params).then(function (response) {
            if (response && response.url) {
              // 上传成功
              successCount++;
              successUrls.push(response.url);
              onSuccess(response.url, file, successUrls);
            } else {
              onError(new Error("\u6587\u4EF6 ".concat(file.name, " \u4E0A\u4F20\u5931\u8D25: \u670D\u52A1\u5668\u8FD4\u56DE\u9519\u8BEF")), file);
            }
          }).catch(function (error) {
            console.error('Upload error:', error);
            onError(error, file);
            errorCount++;
          }).finally(function () {
            // 当所有文件都处理完毕后关闭loading状态
            if (! --totalCount && loadingInstance) {
              loadingInstance.close();
              onComplete(successUrls, errorCount);
            }
          });
        };
        img.src = evt.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  // 触发文件选择对话框
  input.click();
}
var _default = exports.default = {
  uploadLocalImage: uploadLocalImage
};